import classNames from "classnames";
import { HTMLAttributes } from "react";
import mapData from "lib/stores/mapData";
import { useSnapshot } from "valtio";
import styles from "./index.module.scss";
import { colorGrades } from "lib/data/colorScales";
import Color from "colorjs.io";

const ColorLegendScale = () => {
  const { activeCategory } = useSnapshot(mapData, { sync: true });

  const renderColorStops = () => {
    const colors = [];

    switch (activeCategory) {
      case "prevalence":
        colorGrades.prevalenceGrade.forEach((color: string, i: number) => {
          colors.push(color);
        });
        break;
      case "vulnerability":
        colorGrades.vulnerabilityGrade.forEach((color: string, i: number) => {
          colors.push(color);
        });
        break;
      case "gov-response":
        colorGrades.govresponseGrade.forEach((color: string, i: number) => {
          colors.push(color);
        });
        break;
      default:
        return null;
    }

    return colors.map((color: string, i: number) => {
      return (
        <span
          className={classNames(styles["color-legend-scale-grid-item"])}
          style={{
            backgroundColor: color
          }}
          key={color}
        />
      );
    });
  };

  return <div className={classNames(styles["color-legend-scale-grid"])}>{renderColorStops()}</div>;
};

export default ColorLegendScale;
